import { assetsV2Api } from "../../lib/api";
export const searchAssets = async (requestBody, paramsList) => {
    const { applicationSubscriptionName, cursor, downSelectPartyNumber, limit = 20, orderBy, partyNumber, skip, sortBy } = paramsList ?? {};
    const params = {
        ...(partyNumber && { partyNumber }),
        ...(downSelectPartyNumber && { downSelectPartyNumber }),
        ...(applicationSubscriptionName && { applicationSubscriptionName }),
        ...(sortBy && { sortBy: sortBy.join(",") }),
        ...(orderBy && { orderBy: orderBy.join(",") }),
        ...(limit && { limit: String(limit) }),
        ...(skip && { skip: String(skip) }),
        ...(cursor && { cursor })
    };
    const queryParams = new URLSearchParams(params).toString();
    const { data } = await assetsV2Api.post(`/assets/search${queryParams ? "?" + queryParams : ""}`, requestBody);
    return data;
};
export const countAssets = async (requestBody, paramsList) => {
    const { downSelectPartyNumber, partyNumber } = paramsList ?? {};
    const params = {
        ...(partyNumber && { partyNumber }),
        ...(downSelectPartyNumber && { downSelectPartyNumber })
    };
    const queryParams = new URLSearchParams(params).toString();
    const { data } = await assetsV2Api.post(`/assets/COUNT${queryParams ? "?" + queryParams : ""}`, requestBody);
    return data;
};
